/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetPharmaciesErrorResponse,
  GetPharmaciesParams,
  GetPharmaciesResponse,
} from './api.schemas';

import { api } from '../util/http';

export const getPharmacies = (params?: GetPharmaciesParams, signal?: AbortSignal) => {
  return api<GetPharmaciesResponse>({ url: `/api/pharmacies`, method: 'GET', params, signal });
};

export const getGetPharmaciesQueryKey = (params?: GetPharmaciesParams) => {
  return [`/api/pharmacies`, ...(params ? [params] : [])] as const;
};

export const getGetPharmaciesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPharmacies>>,
  TError = GetPharmaciesErrorResponse,
>(
  params?: GetPharmaciesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacies>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPharmaciesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacies>>> = ({ signal }) =>
    getPharmacies(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPharmacies>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPharmaciesQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacies>>>;
export type GetPharmaciesQueryError = GetPharmaciesErrorResponse;

export function useGetPharmacies<
  TData = Awaited<ReturnType<typeof getPharmacies>>,
  TError = GetPharmaciesErrorResponse,
>(
  params: undefined | GetPharmaciesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacies>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacies>>,
          TError,
          Awaited<ReturnType<typeof getPharmacies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPharmacies<
  TData = Awaited<ReturnType<typeof getPharmacies>>,
  TError = GetPharmaciesErrorResponse,
>(
  params?: GetPharmaciesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacies>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacies>>,
          TError,
          Awaited<ReturnType<typeof getPharmacies>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPharmacies<
  TData = Awaited<ReturnType<typeof getPharmacies>>,
  TError = GetPharmaciesErrorResponse,
>(
  params?: GetPharmaciesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacies>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetPharmacies<
  TData = Awaited<ReturnType<typeof getPharmacies>>,
  TError = GetPharmaciesErrorResponse,
>(
  params?: GetPharmaciesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacies>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPharmaciesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
